/** @file Modal: a centred dialog over a dimmed backdrop (a click on the backdrop closes it). */
import type { ReactElement, ReactNode } from 'react';

/** The dialog title, its body, the footer (buttons) and the close callback (backdrop click). */
export type ModalProps = { title: string; children: ReactNode; footer?: ReactNode; onClose: () => void };

/** `role="dialog"`, `aria-modal`, labelled by its title; clicks inside never reach the backdrop. */
export function Modal({ title, children, footer, onClose }: ModalProps): ReactElement {
  return (
    <div className="p3-modal-backdrop" data-testid="modal-backdrop" onClick={onClose}>
      <div className="p3-modal" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => { e.stopPropagation(); }}>
        <h2 className="p3-modal-title">{title}</h2>
        <div className="p3-stack">{children}</div>
        {footer === undefined ? null : <div className="p3-row p3-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
